/**
 * Student portal navigation only.
 * Admins never use this — they use getAdminNavItems + AdminShell.
 *
 * Unpaid students see an "Enroll" tab (choose plan / pay).
 * Paid students see "My Plan" instead (subscription & extensions).
 */
export function getAppNavItems(_isAdmin, activePath, { hasSubscription = true } = {}) {
  const unlocked = Boolean(hasSubscription);

  return [
    {
      icon: 'dashboard',
      label: 'Dashboard',
      path: '/dashboard',
      active: activePath === '/dashboard',
      locked: false,
    },
    {
      icon: unlocked ? 'card_membership' : 'how_to_reg',
      label: unlocked ? 'My Plan' : 'Enroll',
      path: '/billing',
      active: activePath === '/billing',
      locked: false,
    },
    {
      icon: 'receipt_long',
      label: 'Payments',
      path: unlocked ? '/payments' : null,
      active:
        activePath === '/payments' || String(activePath || '').startsWith('/payment-confirmation'),
      locked: !unlocked,
    },
    {
      icon: 'auto_stories',
      label: 'My Course',
      path: unlocked ? '/course' : null,
      active: activePath === '/course',
      locked: !unlocked,
    },
    {
      icon: 'quiz',
      label: 'Practice Exams',
      path: unlocked ? '/exams' : null,
      active: activePath === '/exams',
      locked: !unlocked,
    },
    {
      icon: 'history_edu',
      label: 'My Progress',
      path: unlocked ? '/progress' : null,
      active: activePath === '/progress',
      locked: !unlocked,
    },
    {
      icon: 'forum',
      label: 'Messages',
      path: unlocked ? '/messages' : null,
      active: activePath === '/messages',
      locked: !unlocked,
    },
    {
      icon: 'emoji_events',
      label: 'Achievements',
      path: null,
      locked: true,
    },
    {
      icon: 'person',
      label: 'My Profile',
      path: '/profile',
      active: activePath === '/profile',
      locked: false,
    },
  ];
}
